import { VisualsDashboardWidgetSizingEnum } from 'dashboard/enums/visuals/visuals-dashboard-widget-sizing.enum';

export const iceSizeTypeMapping: Record<VisualsDashboardWidgetSizingEnum, '1x1' | '1x2' | '1x3'> = {
    [VisualsDashboardWidgetSizingEnum.SMALL]: '1x1',
    [VisualsDashboardWidgetSizingEnum.MEDIUM_ROW]: '1x2',
    [VisualsDashboardWidgetSizingEnum.LARGE_ROW]: '1x3',
};

export const iceSizeIdMapping: Record<VisualsDashboardWidgetSizingEnum, number> = {
    [VisualsDashboardWidgetSizingEnum.SMALL]: 1,
    [VisualsDashboardWidgetSizingEnum.MEDIUM_ROW]: 2,
    [VisualsDashboardWidgetSizingEnum.LARGE_ROW]: 3,
};
